import { IconMoney, IconPhoto, IconCards, IconClose } from "@wrstudios/icons";
/**
 * Returns an icon for a history type.
 *
 * @param {String} type
 */
export function getHistoryIconFromType(type) {
    switch (type) {
        case "price":
            return IconMoney;
        case "photos":
            return IconPhoto;
        case "status":
            return IconCards;
        default:
            console.warn("Missing icon for type [" + type + "]");
            return IconClose;
    }
}
